import {DescriptorConverter} from '@sanity/schema/_internal'

export const DESCRIPTOR_CONVERTER = new DescriptorConverter()
